// extracted by mini-css-extract-plugin
export default {"clouds":"CloudEffect_clouds__zHFwc","cloud":"CloudEffect_cloud__pZIaL","drift":"CloudEffect_drift__1UgLz"};